import { DEVICES, OS } from 'src/constants';

export const getDevice = (userAgent = navigator.userAgent.toLowerCase()) => {
    let device = '';
    if (userAgent.indexOf('ipad') > -1) {
        device = DEVICES.TABLET;
    } else if (userAgent.indexOf('iphone') > -1) {
        device = DEVICES.MOBILE;
    } else if (userAgent.indexOf('android') > -1) {
        device = !(userAgent.indexOf('mobile') > -1)
            ? DEVICES.TABLET
            : DEVICES.MOBILE;
    } else if (userAgent.indexOf('windows phone') > -1) {
        device = DEVICES.MOBILE;
    } else if (userAgent.indexOf('mobile') > -1) {
        device = DEVICES.MOBILE;
    } else {
        device = DEVICES.DESKTOP;
    }
    return device;
};

export const getOs = (userAgent = navigator.userAgent.toLowerCase()) => {
    const isIOS = /ipad|iphone|ipod/.test(userAgent);
    return isIOS ? OS.IOS : OS.ANDROID;
};

export const isChrome = (userAgent = navigator.userAgent.toLowerCase()) => {
    const isChrome = /chrome/.test(userAgent);
    return isChrome;
};

export const isIABM = (userAgent = navigator.userAgent.toLowerCase()) => {
    return /bm_iab|newspaperios/.test(userAgent);
};

export const isZalo = (userAgent = navigator.userAgent.toLowerCase()) => {
    return /zalo/.test(userAgent);
};

export const isIAFB = (userAgent = navigator.userAgent.toLowerCase()) => {
    return /fban|fbav/.test(userAgent);
};

export const isUtmZalo = () => {
    return window.location.search?.indexOf('utm_source=zalo') > 0;
};

// export const checkInstallZalo = () => {
//     AppService.checkApp({ installedZalo: true })
//         .then((resp) => {
//             if (resp && resp.data) {
//                 const { installedZalo = false } = resp.data;
//                 (window as any)._BM.installZalo = installedZalo;
//             }
//         })
//         .catch((err) => {
//             if (err) {
//                 Logger.error(err.err, 'checkInstallZalo Fail|', err);
//             }
//         });
// };
